import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import NavButtons from "components/Outdoor_Cameras/IN-9820_QFHD/NavButtons";
import CompareOutdoor from "components/Products/Compare/CompareOutdoorFlyout";
import SmartCards from "components/Products/Flyouts/Cards/9408Cards";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  NavButtons,
  CompareOutdoor,
  SmartCards,
  BreadCrumbs,
  SEOHelmet,
  React
};